export default class {
  constructor() {
    this.address = '';
    this.city = '';
    this.country = '';
    this.email = '';
    this.firstname = '';
    this.lastname = '';
    this.skiResortAddress = '';
    this.zipcode = '';
    this.mobilePhone = '';
  }

  hydrate(data) {
    if (data.address) this.address = data.address;
    if (data.city) this.city = data.city;
    if (data.country) this.country = data.country;
    if (data.email) this.email = data.email;
    if (data.firstname) this.firstname = data.firstname;
    if (data.lastname) this.lastname = data.lastname;
    if (data.skiResortAddress) this.skiResortAddress = data.skiResortAddress;
    if (data.zipcode) this.zipcode = data.zipcode;
    if (data.mobilePhone) this.mobilePhone = data.mobilePhone;
  }
}
